import React from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  FiCalendar,
  FiCheckCircle,
  FiClock,
  FiSlash,
  FiTrendingUp,
  FiUsers,
} from 'react-icons/fi';

import { formatCurrency } from '../../utils/format';

function StatCard({ Icon, label, value, hint, tone = 'blue', loading }) {
  return (
    <div className={`mm-stat mm-stat--${tone}`}>
      <span className="mm-stat__icon" aria-hidden="true">
        <Icon size={18} />
      </span>
      <div className="mm-stat__body">
        <div className="mm-stat__label">{label}</div>
        <div className="mm-stat__value">
          {loading ? <span className="mm-stat__ghost" /> : value}
        </div>
        {hint && !loading && <div className="mm-stat__hint">{hint}</div>}
      </div>
    </div>
  );
}

export default function StatCards({ summary, loading }) {
  const s = summary || {};

  const cards = [
    {
      Icon: FiCalendar,
      label: 'Total appointments',
      value: s.totalAppointments ?? 0,
      hint: `across ${s.activeTherapists ?? 0} therapists`,
      tone: 'blue',
    },
    {
      Icon: FiClock,
      label: 'Upcoming',
      value: s.upcoming ?? 0,
      hint: 'still to take place',
      tone: 'amber',
    },
    {
      Icon: FiCheckCircle,
      label: 'Completed',
      value: s.completed ?? 0,
      hint: `${s.completionRate ?? 0}% attendance`,
      tone: 'green',
    },
    {
      Icon: FiSlash,
      label: 'Cancelled / no-show',
      value: (s.cancelled ?? 0) + (s.noShow ?? 0),
      hint: `${s.cancelled ?? 0} cancelled, ${s.noShow ?? 0} no-show`,
      tone: 'red',
    },
    {
      Icon: FiUsers,
      label: 'Active clients',
      value: s.activeClients ?? 0,
      hint: 'with a booking on record',
      tone: 'violet',
    },
    {
      Icon: FiTrendingUp,
      label: 'Revenue',
      value: formatCurrency(s.revenue, s.currency, { compact: true }),
      hint: 'completed sessions only',
      tone: 'teal',
    },
  ];

  return (
    <Row className="g-3 mb-4">
      {cards.map((card) => (
        <Col key={card.label} xs={12} sm={6} xl={2} lg={4}>
          <StatCard {...card} loading={loading} />
        </Col>
      ))}
    </Row>
  );
}
